import { REQUIREMENTS } from "@/data/brief";
import { BriefField } from "@/components/brief/BriefField";

const RequirementPicker = ({ selected, onSelect }) => (
  <div>
    <span className="label mb-3 block text-[#8a8a8a]">
      <span className="mr-2 text-[#d4ff00]">04</span>WHAT DO YOU NEED?
    </span>
    <div className="grid grid-cols-1 gap-2 sm:grid-cols-3">
      {REQUIREMENTS.map((requirement) => {
        const active = selected === requirement;
        return (
          <button
            key={requirement}
            type="button"
            onClick={() => onSelect(requirement)}
            data-testid={`brief-req-${requirement.toLowerCase().replace(/ /g, "-")}`}
            className="border px-3 py-3.5 label transition-all duration-300"
            style={{
              borderColor: active ? "#d4ff00" : "#262626",
              background: active ? "#d4ff00" : "transparent",
              color: active ? "#0a0a0a" : "#a3a3a3",
            }}
          >
            {requirement}
          </button>
        );
      })}
    </div>
  </div>
);

export const BriefProjectFields = ({ form, setField }) => (
  <>
    <div aria-hidden="true" className="absolute -left-[10000px] h-px w-px overflow-hidden">
      <label>
        Leave this field empty
        <input
          name="website"
          tabIndex={-1}
          autoComplete="off"
          data-testid="brief-honeypot"
          value={form.website}
          onChange={(event) => setField("website", event.target.value)}
        />
      </label>
    </div>
    <RequirementPicker selected={form.requirement} onSelect={(value) => setField("requirement", value)} />
    <BriefField label="Project description" num="05">
      <textarea
        rows={3}
        className="brief-field resize-none"
        placeholder="What is it, who's it for, what should it do?"
        value={form.description}
        onChange={(event) => setField("description", event.target.value)}
        data-testid="brief-description"
        maxLength={4000}
      />
    </BriefField>
    <div className="grid gap-6 sm:grid-cols-2">
      <BriefField label="Deadline" num="06">
        <input
          className="brief-field"
          placeholder="When does it go live?"
          value={form.deadline}
          onChange={(event) => setField("deadline", event.target.value)}
          data-testid="brief-deadline"
          maxLength={200}
        />
      </BriefField>
      <BriefField label="Reference link" num="07">
        <input
          className="brief-field"
          placeholder="Drive / YouTube / Instagram"
          value={form.reference}
          onChange={(event) => setField("reference", event.target.value)}
          data-testid="brief-reference"
          type="url"
          maxLength={2000}
        />
      </BriefField>
    </div>
  </>
);